globalThis.TwoFactorForm = (function() {
  function TwoFactorForm($form) {
    this.$form           = $form;
    this.$group          = this.$form.find(".form-pincode");
    this.$inputs         = this.$group.find(".pincode");
    this.$hiddenOutput   = this.$form.find("#pincode-attempt");
    this.$actionBtn      = this.$form.find("#otp-action-btn");
    this.submitUrl       = this.$actionBtn.data("submit-url");
    this.$backupForm     = $("#otp-backup-form")
    this.$showBackup     = this.$form.find("#show-backup")
    this.$backupOtpInput = $("#white_space_agent_otp_attempt")
    this.completedSteps  = [];
    this.submitting      = false;

    for (i = 0; i <= this.$inputs.length; i ++) {
      this[`$input${i}`] = this.$group.find(`[name=pincode-${i}]`);
    }

    if(this.$form.length) {
      this.init();
    }
  }

  TwoFactorForm.prototype = {
    init: function() {
      this.initInputs();
      this.events();
    },
    events: function() {
      this.preventSubmit();
      this.keepInputFocus();
      this.inputEvents();
      this.initBackUpForm();
    },
    preventSubmit: function() {
      this.$form.submit(function(e) {
        e.preventDefault();
    });
    },
    keepInputFocus: function() {
      var _this = this;

      $("#otp-pincode-form").on("click", function() {
        focused = false;

        _this.$inputs.each(function() {
          if ($(this).is(':focus')) { focused = true; }
        });

        if(!focused) { _this.focusLatestInput(); }
      });
    },
    inputEvents: function() {
      var _this = this;

      $.each(_this.$inputs, function(index, input) {
        var $input = $(input);

        // Prevent clicking and other events and focus last completed input
        $input.on("click mousedown contextmenu", function(e) {
          e.preventDefault();
          _this.focusLatestInput();
        });

        // Handle pasting a code
        $input.on("paste", function(e) {
          _this.handlePaste(e);
        });

        // Store current value of input and keyCode before changing it
        $input.on("keydown", function(e) {
          currentValue   = $(this).val();
          currentKeycode = e.keyCode;

          // Handle arrow keys
          if ([37, 38, 39, 40].includes(currentKeycode)) {
            e.preventDefault();
            return false;
          }
          // Handle backspace
          if (currentKeycode == 8 || currentKeycode == 46) {
            _this.goToPreviousInput();
            return false;
          }
        });

        $input.on("input", function() {
          // Only allow 1 value per input
          if (this.value < 0 || this.value.length == 0 || parseInt(this.value) > parseInt(this.max)) {
            this.value = currentValue;
            return false;
          }

          _this.completedSteps.push(index);
          _this.goToNextInput();
        });
      });
    },
    initInputs: function() {
      var _this = this;
      _this.completedSteps = [];

      _this.$inputs.each(function() { $(this).val(""); });
      _this.$hiddenOutput.val("");

      _this.$inputs.attr("disabled", "disabled");
      $(_this.$inputs.get(0)).removeAttr("disabled").focus();
    },
    goToNextInput: function() {
      var _this = this;

      _this.actionButtonArrow();

      if(_this.completedSteps.length == _this.$inputs.length) {
        _this.$inputs.attr("disabled", "disabled");
        _this.submitForm();
      } else {
        for (i of _this.completedSteps) {
          $input = _this[`$input${i + 1}`];
          $input.removeAttr("disabled").focus();
        }
      }
    },
    goToPreviousInput: function() {
      var _this = this;

      if(_this.completedSteps.length) {
        $.each(_this.$inputs, function(i, input) {
          if($.inArray(i, _this.completedSteps) == -1) {
            $(input).attr("disabled", "disabled")
          }
        });
        _this[`$input${_this.completedSteps.slice(-1)}`].val("").focus();
      } else {
        _this.initInputs();
      }

      _this.completedSteps.pop();
    },
    focusLatestInput: function() {
      var _this = this;

      if(_this.completedSteps.length) {
        _this[`$input${_this.completedSteps.length }`].focus();
      } else {
        _this.$inputs.get(0).focus();
      }
    },
    actionButtonArrow: function() {
      var $innerHtml = "<i class='fa fa-chevron-left position-left'></i> Retour"
      this.$actionBtn.css("pointer-events", "initial").removeClass().addClass("heading-btn btn btn-default");
      this.$actionBtn.html($innerHtml);
    },
    actionButtonLoader: function() {
      var $innerHtml = "<i class='fa fa-spinner fa-spin'></i>"
      this.$actionBtn.css("pointer-events", "none").removeClass().addClass("heading-btn btn btn-primary");
      this.$actionBtn.html($innerHtml)
    },
    actionButtonCheck: function() {
      var $innerHtml = "<i class='fa fa-check'></i>"
      this.$actionBtn.css("pointer-events", "none").removeClass().addClass("heading-btn btn btn-success");
      this.$actionBtn.html($innerHtml)
    },
    actionButtonError: function(message) {
      var _this      = this;
      var $innerHtml = `<i class='fa fa-times position-left'></i> ${message}`

      this.$actionBtn.css("pointer-events", "none").removeClass().addClass("heading-btn btn btn-danger");
      this.$actionBtn.html($innerHtml)

      setTimeout(function() { _this.actionButtonArrow(); } , 1500);
    },
    handlePaste: function(event) {
      var _this = this;
      var pasteData = event.originalEvent.clipboardData.getData('text');
      event.preventDefault();

      if(_this.submitting) { return false; }

      if(pasteData.length == 6 && $.isNumeric(pasteData)) {
        _this.initInputs();
        for(i = 0; i != pasteData.length; i++) {
          _this.completedSteps.push(i);
          _this[`$input${i}`].val(pasteData.charAt(i));
          _this.goToNextInput();
        }
      } else {
        _this.actionButtonError("Valeur copiée non valide");
      }
    },
    handleInvalidCode: function() {
      var _this = this;

      _this.actionButtonError("Code invalide");
      _this.initInputs();
      _this.submitting = false;
    },
    submitForm: function() {
      var _this   = this;
      var output  = [];

      if(!_this.submitting) {
        _this.submitting = true;
        _this.$inputs.each(function() { output.push($(this).val()) });

        _this.$hiddenOutput.val(output.join(""));
        _this.actionButtonLoader();

        $.ajax({
          url: _this.submitUrl,
          method: "POST",
          data: _this.$form.serialize(),
          success: function(data) {
            if(data.response && data.response == 1) {
              _this.actionButtonCheck();
              window.location.replace(data.redirect_url);
            } else {
              _this.handleInvalidCode();
            }
          },
          error: function(data) {
            _this.handleInvalidCode();
          }
        });
      }

    },
    initBackUpForm: function() {
      var _this = this;

      _this.$showBackup.on('click', function() {
        _this.$form.addClass("hide")
        _this.$backupForm.removeClass("hide")
        _this.$backupOtpInput.focus()
      })
    }
  }

  return TwoFactorForm;
})();
